<template>
  <button
    :class="{
      'base-button': true,
      'active': active,
      'disabled': disabled,
      'base-button_green': green,
      'base-button_red': red
    }"
    @click="$emit('clickBtn')"
    :disabled="disabled || loader"
  >
    <slot/>
    {{ name }}
  </button>
</template>

<script>
export default {
  name: 'BaseBtnNew',
  components: {
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    green: {
      type: Boolean,
      default: false
    },
    red: {
      type: Boolean,
      default: false
    },
    white: {
      type: Boolean,
      default: false
    },
    loader: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.base-button {
  display: flex;
  gap: 9px;
  align-items: center;
  padding: 10px 12px;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #FFFFFF;
  background-color: #00ABEC;
  border-radius: 6px;
  transition: 0.8s;
  cursor: pointer;

  @media(any-hover: hover) {
    &:hover {
      background: #0080B0;
      transition: 0.8s;
    }
  }

  &:active {
    background: #006084;
    transition: 0.5s;
  }

  &_red {
    background-color: #C51B0E;

    @media(any-hover: hover) {
      &:hover {
        background: #A11208;
        transition: 0.8s;
      }
    }

    &:active {
      background: #7B0D05;
      transition: 0.5s;
    }
  }

  &_green {
    background-color: #009F30;

    @media(any-hover: hover) {
      &:hover {
        background: #008628;
        transition: 0.8s;
      }
    }

    &:active {
      background: #005219;
      transition: 0.5s;
    }
  }
  &.active {
    background: #0080B1;
  }

  &.disabled {
    opacity: 0.7;
    cursor: not-allowed;
    background-color: #C8C8C8;
    color: #000000;

    :deep(svg) {
      path {
        fill: #00000070 !important;
      }
    }
  }
}

</style>
